import protectedInstance from "../instances/protected";
import {AxiosResponse} from "axios";
import {PaginationResponse, Response} from "../../types/api";
import {Plan, PlanItem, PlanItemList, PlanList} from "../../types/plan";
import {AuctionType, PlanItemState, PlanState, ProductType} from "../../utils/enums";
import {AddressItem} from "../../types/newPlanItem";
import * as util from "node:util";
import {lpad} from "../../utils/utils";

async function createPlan(companyId: number) {
    return protectedInstance
        .post(`/company/${companyId}/plan`, null)
        .then((res: AxiosResponse<Response<Plan>>) => res.data)
}

async function getPlans(
    companyId: number, page: number, pageSize: number,
    year: number | null, planState: PlanState | null
) {
    const query = `page=${page}&page_size=${pageSize}` +
        `&states=${planState || ""}&year=${year || ""}`;

    return protectedInstance
        .get(`/company/${companyId}/plans?${query}`)
        .then((res: AxiosResponse<PaginationResponse<PlanList[]>>) => res.data)
}

async function getPlan(companyId: number, planId: number) {
    return protectedInstance
        .get(`/company/${companyId}/plan/${planId}`)
        .then((res: AxiosResponse<Response<Plan>>) => res.data)
}

async function getPlanItems(planId: number, companyId: number, page: number, pageSize: number, name: string | null, auctionType: AuctionType | null, state: PlanItemState | null,
                            auctionDate: Date | null, productType: ProductType | null, lang: string = 'ru') {
    const query = `page=${page}&page_size=${pageSize}&productName=${name || ""}&auctionType=${auctionType || ""}&state=${state || ""}&auctionDate=${!!auctionDate ? auctionDate.getFullYear() + '-' + lpad((auctionDate.getMonth() + 1), 2, '0') + '-01' : ""}&productType=${productType || ""}`

    return protectedInstance
        .get(`/company/${companyId}/plan/${planId}/planItems?${query}`, { headers: { "Accept-Language": lang }})
        .then((res: AxiosResponse<PaginationResponse<Plan[]>>) => res.data)
}

async function getPlanItemsWithoutPlan(companyId: number, searchText: string | null, page: number, pageSize: number
    , financialYear: number, auctionType: AuctionType, planItemStates: PlanItemState[], productType: ProductType) {
    const query = `q=${searchText || ''}&page=${page}&page_size=${pageSize}&financialYear=${financialYear}&auctionType=${auctionType}&state=${planItemStates.join(',')}&productType=${productType}`

    return protectedInstance
        .get(`/company/${companyId}/planItems?${query}`)
        .then((res: AxiosResponse<PaginationResponse<PlanItemList[]>>) => res.data)
}

async function createPlanItem(companyId: number, planId: number, data: any) {
    return protectedInstance
        .post(`/company/${companyId}/plan/${planId}/planItem`, data)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function deletePlanItem(companyId: number, planId: number, itemId: number) {
    return protectedInstance
        .delete(`/company/${companyId}/plan/${planId}/planItem/${itemId}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function editPlanItem(companyId: number, planId: number, itemId: number, data: any) {
    return protectedInstance
        .put(`/company/${companyId}/plan/${planId}/planItem/${itemId}`, data)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}


async function getPlanItem(companyId: number, planId: number, itemId: number) {
    return protectedInstance
        .get(`/company/${companyId}/plan/${planId}/planItem/${itemId}`)
        .then((res: AxiosResponse<Response<PlanItem>>) => res.data)
}


async function deletePlan(companyId: number, planId: number) {
    return protectedInstance
        .delete(`/company/${companyId}/plan/${planId}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function approvePlan(companyId: number, planId: number) {
    return protectedInstance
        .put(`/company/${companyId}/plan/${planId}/approve`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function deletePlanItemAddress(companyId: number, planId: number, planItemId: number, id: number) {
    return protectedInstance
        .delete(`/company/${companyId}/plan/${planId}/planItem/${planItemId}/address/${id}`)
        .then((res: AxiosResponse<Response<any>>) => res.data)
}

async function updatePlanItemAddress(companyId: number, planId: number, planItemId: number, id: number, data: AddressItem) {
    return protectedInstance
        .put(`/company/${companyId}/plan/${planId}/planItem/${planItemId}/address/${id}`, data)
        .then((res: AxiosResponse<Response<AddressItem>>) => res.data)
}

async function addPlanItemAddress(companyId: number, planId: number, planItemId: number, data: AddressItem) {
    return protectedInstance
        .post(`/company/${companyId}/plan/${planId}/planItem/${planItemId}/address`, data)
        .then((res: AxiosResponse<Response<AddressItem>>) => res.data)
}
export const planService = {
    createPlan,
    getPlans,
    getPlan,
    getPlanItems,
    createPlanItem,
    deletePlanItem,
    editPlanItem,
    getPlanItem,
    deletePlan,
    approvePlan,
    getPlanItemsWithoutPlan,
    deletePlanItemAddress,
    updatePlanItemAddress,
    addPlanItemAddress
}